import { BookOpen, Trash2 } from "lucide-react";
import { Button } from "./ui/button";

export default function FavoritesGallery({ favorites, onOpen, onRemove }) {
  if (!favorites || favorites.length === 0) {
    return (
      <div
        className="text-center text-slate-400 py-10"
        data-testid="favorites-empty"
      >
        <BookOpen className="w-8 h-8 mx-auto mb-3 text-amber-400/60" />
        <p>Aún no tienes cuentos guardados.</p>
        <p className="text-sm">Crea uno y pulsa el corazón para guardarlo aquí.</p>
      </div>
    );
  }

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
      data-testid="favorites-grid"
    >
      {favorites.map((s) => (
        <div
          key={s.id}
          className="group relative bg-slate-800/40 backdrop-blur-md border border-white/10 hover:border-amber-400/50 rounded-2xl p-5 transition-all hover:-translate-y-1 cursor-pointer"
          onClick={() => onOpen(s)}
          data-testid={`favorite-card-${s.id}`}
        >
          <h3 className="font-[Fredoka] text-lg font-semibold text-amber-200 mb-2 line-clamp-2">
            {s.title}
          </h3>
          <p className="text-sm text-slate-400 line-clamp-3 leading-relaxed">
            {s.paragraphs?.[0]}
          </p>
          <div className="text-xs text-slate-500 mt-3">
            {new Date(s.created_at).toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(s.id);
            }}
            data-testid={`favorite-remove-${s.id}`}
            className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 text-rose-300 hover:bg-rose-500/10 rounded-full"
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
